import { SleepCycleChart } from './SleepCycleChart.ts';

document.addEventListener('DOMContentLoaded', () => {
    // --- 1. ターゲット要素の取得 (新仕様: Role属性ベース) ---
    // data-chart-role="container" かつ data-chart-type="sleep-cycle-chart" の要素を検索
    const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="sleep-cycle-chart"]');

    chartWrappers.forEach(wrapper => {
        const initializeChart = async () => {
            // --- 2. 内部要素の取得 (新仕様: Role属性ベース) ---
            const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
            // PHPヘルパーが出力するコントロール用コンテナ (c-chart-controls)
            const controlsContainer = wrapper.querySelector('[data-chart-role="controls"]');

            if (!chartArea) {
                console.error('[sleep-cycle-chart] Error: Chart area (role="chart-area") not found.');
                return;
            }

            if (chartArea._chartInstance) {
                return; // 二重初期化防止
            }

            // --- 3. グラフインスタンスの生成 ---
            const chart = new SleepCycleChart(chartArea, {});
            chartArea._chartInstance = chart;
            chartArea.dataset.chartInstance = 'true';

            try {
                // --- 4. 非同期初期化 ---
                await chart.init();

                // --- 5. UI構築 (コントロールコンテナがある場合のみ) ---
                if (controlsContainer) {
                    // 5a. ユーザー操作の管理フラグ
                    let userHasInteracted = false;
                    const handleUserInteraction = () => {
                        if (!userHasInteracted) {
                            userHasInteracted = true;
                            chart.config.autoplay = false; // 初回操作で自動再生を無効化
                        }
                    };

                    // 5b. UI要素の動的生成
                    controlsContainer.innerHTML = `
                        <button class="play-pause-button" aria-label="再生/一時停止"></button>
                        <input type="range" class="time-slider" min="0" max="0" value="0" step="1" aria-label="アニメーションのスライダー">
                        <span class="current-year-display"></span>
                    `;

                    // 5c. 生成した要素への参照取得
                    const playPauseButton = controlsContainer.querySelector('.play-pause-button');
                    const slider = controlsContainer.querySelector('.time-slider');
                    const yearDisplay = controlsContainer.querySelector('.current-year-display');

                    // 5d. イベントリスナーを設定
                    if (playPauseButton) {
                        playPauseButton.addEventListener('click', () => {
                            handleUserInteraction();
                            chart.togglePlayPause();
                        });
                    }
                    if (slider) {
                        slider.addEventListener('input', () => {
                            handleUserInteraction();
                            const frame = parseInt(slider.value, 10);
                            chart.seek(frame);
                        });
                    }

                    // 5e. グラフからのUI更新コールバック
                    chart.onUpdateUI(state => {
                        // 再生中クラスはラッパーに付与 (共通CSSがこれを利用してアイコンを切り替える)
                        wrapper.classList.toggle('is-playing', state.isPlaying);

                        if (slider) {
                            const totalFrames = state.totalFrames > 0 ? state.totalFrames - 1 : 0;
                            if (slider.max != totalFrames) {
                                slider.max = totalFrames;
                            }
                            slider.value = state.currentFrame;
                        }
                        
                        if (yearDisplay) {
                            yearDisplay.textContent = state.currentYear || '';
                        }
                    });

                    // 5f. 自動再生トリガー
                    // ユーザー操作がない場合のみ自動再生ボタンを押す
                    // if (chart.config.autoplay) {
                    //     setTimeout(() => {
                    //         if (!userHasInteracted && playPauseButton) {
                    //             playPauseButton.click();
                    //         }
                    //     }, chart.config.autoplayDelay);
                    // }
                } else {
                    console.warn('[sleep-cycle-chart] Warning: Controls container (role="controls") not found.');
                }

            } catch (error) {
                console.error('[sleep-cycle-chart] Initialization failed:', error);
            }
        };

        initializeChart();
    });
});